// Saved Unify version (v1/v2). Kept across logout so a returning v2 user loads v2 directly
// instead of rendering v1 first and then switching.
export const UNIFY_VERSION_KEY = 'unify-user-version';

// Clears localStorage on logout, keeping the DMS "remember*" keys and the Unify version.
export const clearLocalStorageExceptDMS = () => {
  Object.keys(localStorage).forEach((key) => {
    if (!key.startsWith('remember') && key !== UNIFY_VERSION_KEY) {
      localStorage.removeItem(key);
    }
  });
};
